"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryRecommended = exports.query = exports.listPendingRequests = exports.updateGroup = exports.create = exports.getGroup = void 0;
const constants_1 = require("../constants");
function getGroup({ id, autoInviteId, }) {
    return {
        method: 'GET',
        params: {
            autoInviteId,
        },
        url: `/${constants_1.serverlessBaseURL}/group/${id}`,
    };
}
exports.getGroup = getGroup;
function create(data) {
    return {
        method: 'POST',
        data,
        url: `/${constants_1.serverlessBaseURL}/group/create`,
    };
}
exports.create = create;
function updateGroup({ group, groupId, }) {
    return {
        method: 'PATCH',
        data: group,
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}`,
    };
}
exports.updateGroup = updateGroup;
function listPendingRequests({ groupId, }) {
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/list-pending-requests`,
    };
}
exports.listPendingRequests = listPendingRequests;
function query(data) {
    return {
        method: 'POST',
        data,
        url: `/${constants_1.serverlessBaseURL}/groups/query`,
    };
}
exports.query = query;
function queryRecommended(data) {
    return {
        method: 'POST',
        data,
        url: `/${constants_1.serverlessBaseURL}/groups/query-recommended`,
    };
}
exports.queryRecommended = queryRecommended;
//# sourceMappingURL=http.js.map